var render = function render(){var _vm=this,_c=_vm._self._c;return _c('panel-navigation',[_c('h1',{staticClass:"text-lg font-semibold mb-4"},[_vm._v("Reviews")]),_c('hr',{staticClass:"border-b border-gray-100"}),_c('br'),_c('div',{staticClass:"reviews-section-wrapper"},[_c('ReviewsTable',{attrs:{"dashboard":"false","social_posting":"false"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }